import classnames from 'classnames';
import Utils from 'Utils';
import evtBus from 'evtBus';
import React, { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import ReactDOM from 'react-dom';
import { Icon, Button, Typography, message, Spin, Modal } from 'antd';
import Loading from 'ui-loading';
import Err from 'ui-error';
import request from 'request';
import Install from 'install';
import useFooter from 'useFooter';
import App from './app'

function ExtApp(route) {
  useFooter()

  const ID = route.match.params.id || ''
  const [extUuid, extVersionData] = ID.split('-')

  const fetch = useMemo(() => request({
    type: 'GET',
    url: request.api.extDetail,
    data: { extUuid, [extVersionData?.includes('.') ? 'extVersion' : 'extVersionId']: extVersionData },
  }), [])

  let [fetchRes, setFetchRes] = useState(null)

  yaReportArr.push({
    eid: 'sys/pageview/appstore/extDetail',
    eid_desc: '小程序商店/详情页',
    prop: JSON.stringify({
      extId: ID,
    }),
  })

  useEffect(() => {
    fetch.done(data => setFetchRes({ data }))
    fetch.fail(err => setFetchRes({ err }))

    return () => {
      setFetchRes = () => { }
    }
  }, [])

  const elmLoading = fetch.state() == 'pending' ? <Loading /> : null
  const elmErr = fetch.state() == 'rejected' ? <Err err={`获取数据失败：${fetchRes.err}`} /> : null
  const elmApp = fetch.state() == 'resolved' ? (
    <App
      data={fetchRes.data}
      install={new Install(fetchRes.data)}
    />
  ) : null

  return (
    <div>
      {elmLoading}
      {elmErr}
      {elmApp}
    </div>
  )
}


export default ExtApp;